<template>
  <div v-if="useDesignV2" id="app" class="kn-shell" :class="{'kn-shell--collapsed': sidebarCollapsed}">
    <app-sidebar :open="sidebarOpen" @close="sidebarOpen = false"></app-sidebar>
    <div v-if="sidebarOpen" class="kn-shell__backdrop" @click="sidebarOpen = false"></div>

    <div class="kn-shell__main">
      <app-topbar
        @toggle-sidebar="sidebarOpen = !sidebarOpen"
        @open-search="$refs.palette.open()"
      ></app-topbar>

      <main v-if="user.id" class="kn-shell__content">
        <router-view v-if="user.roles.length" />
        <user-no-role-overlay v-if="!user.roles.length" />
      </main>
    </div>

    <mobile-bottom-nav
      @open-search="$refs.palette.open()"
      @open-menu="sidebarOpen = true"
    ></mobile-bottom-nav>

    <command-palette
      ref="palette"
      :menu-root="getMenuRoot"
    ></command-palette>
  </div>

  <el-container v-else id="app">
    <el-header class="app-header">

      <div style="display: flex; align-items: center;">
        <div style="margin-right:10px">
          <router-link :to="{name: 'Home'}">
            <img alt="Главная" height="25" src="@/assets/img/logo.png"/>
          </router-link>
        </div>


        <menu-component ref="mainMenu"></menu-component>

      </div>
      <div>

        <actions-component></actions-component>

      </div>
    </el-header>
    <el-main v-if="user.id">
      <router-view v-if="user.roles.length" />
      <user-no-role-overlay v-if="!user.roles.length" />
    </el-main>
  </el-container>

</template>

<script>
import {mapGetters} from 'vuex';
import MenuComponent from "@/components/header/MenuComponent.vue";
import ActionsComponent from "@/components/header/ActionsComponent.vue";
import UserNoRoleOverlay from "@/components/user/UserNoRoleOverlay.vue";
import AppSidebar from "@/components/designV2/AppSidebar.vue";
import AppTopbar from "@/components/designV2/AppTopbar.vue";
import MobileBottomNav from "@/components/designV2/MobileBottomNav.vue";
import CommandPalette from "@/components/designV2/CommandPalette.vue";

export default {
  name: "default-layout",
  components: {
    UserNoRoleOverlay, ActionsComponent, MenuComponent,
    AppSidebar, AppTopbar, MobileBottomNav, CommandPalette,
  },

  computed: {
    ...mapGetters(['user']),
    ...mapGetters('settings', ['useDesignV2', 'sidebarCollapsed']),
    layout() {
      return this.$route.meta.layout || 'default-layout'
    }
  },

  data() {
    return {
      version: process.env.PACKAGE_VERSION,
      sidebarOpen: false,
    }
  },

  created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('settings/loadSettings');
  },

  mounted() {
    // window.addEventListener('resize', function(event) {
    //   console.log("2314234");
    // }, true);
  },
  updated() {
    // this.doMenuSize();
  },
  methods: {
    getMenuRoot() {
      return this.$el.querySelector('.kn-sidebar__nav');
    },
    async doMenuSize(){
      let menuHeight = document.getElementsByClassName("app-header")[0].scrollHeight;

      // Меню в одну строку, все ок
      if( menuHeight < 60 ){
        return;
      }

      const menuItems = document.querySelectorAll(".el-submenu__title,.el-menu-item,.header-actions");
      if( !menuItems.length ){
        return;
      }

      let currentFontSize = parseFloat(window.getComputedStyle(menuItems[0], null).getPropertyValue('font-size'));
      let currentPadding = parseFloat(window.getComputedStyle(menuItems[0], null).getPropertyValue('padding').split(' ')[1]);



      const currentFontSizeLimit = 5;
      const currentPaddingLimit = 5;

      while (menuHeight >= 60 && currentPadding >= currentPaddingLimit && currentFontSize >= currentFontSizeLimit){

        if( currentPadding >= currentPaddingLimit ){
          currentPadding = currentPadding-3;
        }
        if( currentFontSize >= currentFontSizeLimit ){
          currentFontSize--;
        }

        menuItems.forEach(item => {
          item.style.fontSize = currentFontSize + 'px';
          item.style.padding = '0 ' + currentPadding + 'px';
        });

        await this.$nextTick();
        menuHeight = document.getElementsByClassName("app-header")[0].scrollHeight;
      }
    }
  }

}
</script>

<style lang="scss">
@import "@/assets/css/project-variables";


.app-header{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  height: 41px;
  border-bottom: solid 1px #e6e6e6;
  align-items: center;
  background-color: white;
}

.el-avatar > img {
  display: unset;
  height: unset;
  width: 100%;
}

.kn-shell {
  min-height: 100vh;
  background-color: var(--kn-bg);

  &__main {
    margin-left: var(--kn-sidebar-width);
    min-width: 0;
    transition: margin-left .2s ease;
  }

  &--collapsed &__main {
    margin-left: var(--kn-sidebar-collapsed-width);
  }

  &__content {
    display: block;
    width: 100%;
    max-width: none;
    margin: 0;
    padding: 24px;
    box-sizing: border-box;
  }

  &__backdrop {
    display: none;
  }
}

@media (max-width: 1023px) {
  .kn-shell {
    &__main { margin-left: 0; }

    &__backdrop {
      display: block;
      position: fixed;
      inset: 0;
      z-index: 1000;
      background-color: var(--kn-overlay);
    }
  }
}

@media (max-width: 767px) {
  .kn-shell__content {
    padding: 16px 12px calc(var(--kn-bottom-nav-height) + 16px);
  }
}

</style>